import { gql } from '@apollo/client'

export const UPDATE_COUNTRY_VERSION = gql`
  mutation updateCountryVersion($input: UpdateCountryVersionInput!) {
    data: updateCountryVersion(input: $input) {
      id
    }
  }
`
